export default class KvTxtImg {
  constructor({
    txtImgTargetClass = 'js-kv_txt_img',
    txtImgActiveClass = 'is-txt_img_active',
    txtImgContainerSelector = '.p-index__kv_txt_img',
    txtImgSpSelector = '.js-kv_txt_img_sp',
    txtImgSpMaxIndex = 6,
    txtImgPcMaxIndex = 10,
    txtImgPcWindowSize = 5,
    txtImgPcBoxSelectors = [],
    txtImgFadeDurationMs = 400,
    spMediaQuery = window.matchMedia('(max-width: 767px)')
  } = {}) {
    this.txtImgTargetClass = txtImgTargetClass;
    this.txtImgActiveClass = txtImgActiveClass;
    this.txtImgContainerSelector = txtImgContainerSelector;
    this.txtImgSpSelector = txtImgSpSelector;
    this.txtImgSpMaxIndex = txtImgSpMaxIndex;
    this.txtImgPcMaxIndex = txtImgPcMaxIndex;
    this.txtImgPcWindowSize = txtImgPcWindowSize;
    this.txtImgPcBoxSelectors = txtImgPcBoxSelectors;
    this.txtImgFadeDurationMs = txtImgFadeDurationMs;
    this.spMediaQuery = spMediaQuery;
    this.txtImgElems = document.querySelectorAll(`.${this.txtImgTargetClass}`);
    this.txtImgBaseUrl = '';
    this.txtImgSpBox = null;
    this.txtImgSpImg = null;
    this.txtImgSpIndex = 1;
    this.txtImgSpCycleTimer = null;
    this.txtImgPcBoxes = [];
    this.txtImgPcImgs = [];
    this.txtImgPcStartIndex = 10;
    this.txtImgPcCycleTimer = null;
  }

  isSpViewport() {
    return this.spMediaQuery.matches;
  }

  // 画像の基準となるURLを取得する
  resolveTxtImgBaseUrl() {
    const container = document.querySelector(this.txtImgContainerSelector);
    const fallbackBox = document.querySelector(this.txtImgSpSelector);

    return container?.dataset.kvTxtImgBase || fallbackBox?.dataset.kvTxtImgBase || '';
  }

  getTxtImgUrl(index) {
    return `${this.txtImgBaseUrl}${index}.png`;
  }

  // maxIndexの数だけgetTxtImgUrlを呼び出して、画像をプリロードする
  preloadTxtImages(maxIndex) {
    for (let index = 1; index <= maxIndex; index += 1) {
      const image = new Image();
      image.src = this.getTxtImgUrl(index);
    }
  }

  init() {
    this.txtImgBaseUrl = this.resolveTxtImgBaseUrl();
    if (!this.txtImgBaseUrl) {
      return;
    }

    if (this.isSpViewport()) {
      this.initSpTxtImg();
      return;
    }

    this.initPcTxtImg();
  }

  initSpTxtImg() {
    this.txtImgSpBox = document.querySelector(this.txtImgSpSelector);
    if (!this.txtImgSpBox) {
      return;
    }

    this.txtImgSpImg = this.txtImgSpBox.querySelector('img');
    if (!this.txtImgSpImg) {
      return;
    }

    this.txtImgSpIndex = 1;
    this.preloadTxtImages(this.txtImgSpMaxIndex);
  }

  initPcTxtImg() {
    this.txtImgPcBoxes = this.txtImgPcBoxSelectors
      .map((selector) => document.querySelector(selector))
      .filter(Boolean);

    if (this.txtImgPcBoxes.length !== this.txtImgPcWindowSize) {
      return;
    }

    this.txtImgPcImgs = this.txtImgPcBoxes.map((box) => box.querySelector('img'));
    if (this.txtImgPcImgs.some((img) => !img)) {
      return;
    }

    this.txtImgPcStartIndex = 10;
    this.preloadTxtImages(this.txtImgPcMaxIndex);
  }

  showAll() {
    this.txtImgElems.forEach((elem) => elem.classList.add(this.txtImgActiveClass));
  }

  getPcWindowNumbers(startIndex) {
    const numbers = [];

    for (let offset = 0; offset < this.txtImgPcWindowSize; offset += 1) {
      let number = startIndex + offset;
      if (number > this.txtImgPcMaxIndex) {
        number -= this.txtImgPcMaxIndex;
      }
      numbers.push(number);
    }

    return numbers;
  }

  advancePcStartIndex() {
    if (this.txtImgPcStartIndex >= this.txtImgPcMaxIndex) {
      this.txtImgPcStartIndex = 1;
      return;
    }

    this.txtImgPcStartIndex += 1;
  }

  applyPcTxtImgWindow(startIndex) {
    const numbers = this.getPcWindowNumbers(startIndex);

    numbers.forEach((number, index) => {
      this.txtImgPcImgs[index].src = this.getTxtImgUrl(number);
    });
  }

  clearCycleTimer() {
    if (this.txtImgSpCycleTimer !== null) {
      window.clearTimeout(this.txtImgSpCycleTimer);
      this.txtImgSpCycleTimer = null;
    }

    if (this.txtImgPcCycleTimer !== null) {
      window.clearTimeout(this.txtImgPcCycleTimer);
      this.txtImgPcCycleTimer = null;
    }
  }

  cycleSpTxtImg() {
    if (!this.isSpViewport() || !this.txtImgSpBox || !this.txtImgSpImg) {
      return;
    }

    this.clearCycleTimer();
    this.txtImgSpBox.classList.remove(this.txtImgActiveClass);

    this.txtImgSpCycleTimer = window.setTimeout(() => {
      this.txtImgSpCycleTimer = null;
      this.txtImgSpIndex =
        this.txtImgSpIndex >= this.txtImgSpMaxIndex ? 1 : this.txtImgSpIndex + 1;
      this.txtImgSpImg.src = this.getTxtImgUrl(this.txtImgSpIndex);
      this.txtImgSpBox.classList.add(this.txtImgActiveClass);
    }, this.txtImgFadeDurationMs);
  }

  cyclePcTxtImg() {
    if (this.isSpViewport() || this.txtImgPcBoxes.length !== this.txtImgPcWindowSize) {
      return;
    }

    this.clearCycleTimer();
    this.txtImgPcBoxes.forEach((box) => box.classList.remove(this.txtImgActiveClass));

    this.txtImgPcCycleTimer = window.setTimeout(() => {
      this.txtImgPcCycleTimer = null;
      this.advancePcStartIndex();
      this.applyPcTxtImgWindow(this.txtImgPcStartIndex);
      this.txtImgPcBoxes.forEach((box) => box.classList.add(this.txtImgActiveClass));
    }, this.txtImgFadeDurationMs);
  }

  cycle() {
    if (this.isSpViewport()) {
      this.cycleSpTxtImg();
      return;
    }

    this.cyclePcTxtImg();
  }
}
